import { render } from "./InputSubmit.vue?vue&type=template&id=091160ae"
import script from "./InputSubmit.vue?vue&type=script&lang=js"
export * from "./InputSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__